import { useRouteLoaderData } from 'react-router'

import { ProviderRootLoaderData } from '~/routes/sp-admin/loader'
import { ConsumerOfflineStatusData, ProviderOfflineStatusData } from '~/routes/sp-portal/loader'
import { ConsumerLoaderData, ShubOrgInfo } from '~/types/portal'

export const useShubOrgInfo = (): ShubOrgInfo => {
  const loaderData = useRouteLoaderData<ProviderRootLoaderData>('routes/sp-admin/_index')
    || useRouteLoaderData<ConsumerLoaderData>('routes/_docs/_index')
    || useRouteLoaderData<ConsumerOfflineStatusData | ProviderOfflineStatusData>('routes/sp-portal/_index')
  const organizationRole = loaderData?.organizationRole
  const highestRole = loaderData?.highestRole
  const swaggerhubOrgName = loaderData?.swaggerhubOrgName || ''
  const swaggerhubOrgDisplayName = loaderData?.swaggerhubOrgDisplayName || ''
  const swaggerhubOrgId = loaderData?.swaggerhubOrgId || ''
  
  return { organizationRole, swaggerhubOrgName, swaggerhubOrgDisplayName, highestRole, swaggerhubOrgId }
}